import React, { useState } from "react";
import {
  CommonDeleteModal,
  // CommonActionModal,
  MuiBox,
  MuiIconButton,
  MuiTypography,
} from "components/atoms";
import { Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { openCenterModal } from "store/slices/CenterModal.slice";
import { useTranslation } from "react-i18next";

// Modals
import CreateRenameModal from "../CreateRenameModal";
import InformationModal from "../InformationModal";
import ShareFolderModal from "../ShareFolderModal";
import MoveFileFolderModal from "../MoveFileFolderModal";
// import BlockUserModal from "../BlockUserModal";
// import ReportModal from "../ReportModal";

// Icons
import MoreIcon from "assets/images/svg-icons/morevert.svg";
import DownloadIcon from "assets/images/svg-icons/download.svg";
import RenameIcon from "assets/images/svg-icons/rename.svg";
import ShareIcon from "assets/images/svg-icons/share2.svg";
import OrganizeIcon from "assets/images/svg-icons/organize.svg";
import RemoveIcon from "assets/images/svg-icons/trash2.svg";
import StarIcon from "assets/images/svg-icons/star.svg";
import StarFillIcon from "assets/images/svg-icons/starFill.svg";
import LockedIcon from "assets/images/svg-icons/locked.svg";
import UnlockedIcon from "assets/images/svg-icons/unlocked.svg";
// import BlockIcon from "assets/images/svg-icons/blockicon.svg";
// import ReportIcon from "assets/images/svg-icons/report.svg";
import CopyIcon from "assets/images/svg-icons/copyLink.svg";
import InfoIcon from "assets/images/svg-icons/info.svg";
import RestoreIcon from "assets/images/svg-icons/restore.svg";
import DeleteForeverIcon from "assets/images/svg-icons/deleteforever.svg";
import RightArrow from "assets/images/svg-icons/chevron-right.svg";
import MoveIcon from "assets/images/svg-icons/moveicon.svg";
import {
  DeletePermanentlyFilesFolderAction,
  DownloadFileFolderZIPAction,
  RestoreFilesFolderAction,
  StarUnstarFileFolderAction,
  TrashFilesFolderAction,
} from "store/middlewares/general";
import { useHandleCopy } from "utils/Commonfunctions";
import { CreateShareLinkFileFolderAction } from "store/middlewares/folders";
import VerifyPassword from "../VerifyPassword";

const FolderMenu = ({
  page,
  item,
  clearSelection,
  selectedItems = [],
  contextMenu,
  setContextMenu,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuAnchor, setSubmenuAnchor] = useState(null);
  const [submenuItems, setSubmenuItems] = useState([]);
  const [activeParent, setActiveParent] = useState(null);
  const open = Boolean(anchorEl || contextMenu);
  const submenuOpen = Boolean(submenuAnchor);
  const handleCopy = useHandleCopy();
  const { drivePrefrences } = useSelector((state) => state.profile);
  const { driveData } = useSelector((state) => state.folders);
  const selectedIds = selectedItems.some(
    (selectedItem) => selectedItem.id === item?.id,
  )
    ? selectedItems.map((selectedItem) => selectedItem.id)
    : [item?.id];


  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu?.(null);
    setSubmenuAnchor(null);
    setSubmenuItems([]);
    setActiveParent(null);
  };

  const handleSubmenuOpen = (event, items, idx) => {
    setSubmenuAnchor(event.currentTarget);
    setSubmenuItems(items);
    setActiveParent(idx);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchor(null);
    setSubmenuItems([]);
    setActiveParent(null);
  };

  const folderOptions = [
    ...(item?.permission !== "view" && selectedIds.length <= 1
      ? [
        {
          label: t("common.share"),
          icon: ShareIcon,
          onClick: () =>
            dispatch(
              openCenterModal({
                maxWidth: "600px",
                content: (
                  <ShareFolderModal
                    title={t("modal.shareFileFolder.shareFolder")}
                    fileType={"folder"}
                    id={item?.id}
                    isEditor={item?.permission !== "view"}
                  />
                ),
              }),
            ),
        },
      ]
      : []),
    ...(selectedIds.length <= 1 ?
      [{
        label: t("common.copyLink"),
        icon: CopyIcon,
        onClick: () => {
          if (
            item?.general_access !== null &&
            !!item?.general_access?.shared_link
          ) {
            handleCopy(
              item?.general_access?.shared_link,
              t("common.copiedLinktoClipboard"),
            );
          } else {
            const payload = {
              fileType: "folder",
              folderId: item?.id,
              visibility: "restricted",
              onSuccess: (data) => {
                handleCopy(data?.access_link, t("common.copiedLinktoClipboard"));
              },
            };
            dispatch(CreateShareLinkFileFolderAction(payload));
          }
        },
      }
      ] : []),
    {
      label: t("common.organize"),
      icon: OrganizeIcon,
      rightArrow: true,
      submenu: [
        // (item?.permission === "owner" || item?.permission === "edit") && {
        item?.permission === "owner" && {
          label: t("common.move"),
          icon: MoveIcon,
          onClick: () =>
            dispatch(
              openCenterModal({
                content: (
                  <MoveFileFolderModal
                    parentIds={[item?.parent_id]}
                    folderIds={selectedIds}
                    onClose={handleClose}
                    clearSelection={clearSelection}
                  />
                ),
              }),
            ),
        },
        {
          label: t(
            (selectedItems?.length > 0 && selectedItems.some((s) => s.id === item?.id)
              ? selectedItems.every((i) => i.isStar || i.is_starred)
              : item?.is_starred || item?.isStar)
              ? "common.removeFormStarred"
              : "common.addToStarred"
          ),
          icon:
            (selectedItems?.length > 0 && selectedItems.some((s) => s.id === item?.id)
              ? selectedItems.every((i) => i.isStar || i.is_starred)
              : item?.is_starred || item?.isStar)
              ? StarFillIcon
              : StarIcon,
          onClick: () => {
            const isMultiple =
              selectedItems?.length > 0 &&
              selectedItems.some((s) => s.id === item?.id);
            const items = isMultiple ? selectedItems : [item];
            const allStarred = items.every((i) => i.isStar || i.is_starred);
            const allUnstarred = items.every((i) => !(i.isStar || i.is_starred));
            const itemsToUpdate =
              allStarred || allUnstarred
                ? items
                : items.filter((i) => !(i.isStar || i.is_starred));

            dispatch(
              StarUnstarFileFolderAction({
                isStarred: !allStarred,
                fileIds: itemsToUpdate
                  .filter((i) => i.type === "file")
                  .map((i) => i.id),
                folderIds: itemsToUpdate
                  .filter((i) => (i.type ? i.type === "folder" : true))
                  .map((i) => i.id),
                onSuccess: () => {
                  clearSelection?.();
                },
              }),
            );
          },
        },
        drivePrefrences?.drive_secure_enabled === "true" &&
        drivePrefrences?.drive_is_secure === "true" && {
          // item?.permission !== "view" && {
          label: t(
            (selectedItems?.length > 0 && selectedItems.some((s) => s.id === item?.id)
              ? selectedItems.every((i) => i.isSecure || i.is_secure)
              : item?.is_secure || item?.isSecure)
              ? "common.unlock"
              : "common.lock"
          ),
          icon:
            (selectedItems?.length > 0 && selectedItems.some((s) => s.id === item?.id)
              ? selectedItems.every((i) => i.isSecure || i.is_secure)
              : item?.is_secure || item?.isSecure)
              ? UnlockedIcon
              : LockedIcon,
          onClick: () => {
            const isMultiple = selectedItems?.length > 0 && selectedItems.some((s) => s.id === item?.id);
            const items = isMultiple ? selectedItems : [item];
            const allLocked = items.every((i) => i.isSecure || i.is_secure);
            const allUnlocked = items.every((i) => !(i.isSecure || i.is_secure));
            const itemsToUpdateInLock =
              allLocked || allUnlocked
                ? items
                : items.filter((i) => !(i.isSecure || i.is_secure));

            const lockPayload = {
              fileIds: itemsToUpdateInLock
                .filter((i) => i.type === "file")
                .map((i) => i.id),
              folderIds: itemsToUpdateInLock
                .filter((i) => (i.type ? i.type === "folder" : true))
                .map((i) => i.id),
              action: allLocked ? "unsecure" : "secure",
            };

            dispatch(
              openCenterModal({
                content: (
                  <VerifyPassword
                    item={item}
                    clearSelection={clearSelection}
                    onClose={handleClose}
                    payload={lockPayload}
                  />
                ),
              }),
            );
          },
        },
      ].filter(Boolean),
    },
    {
      label: t("common.download"),
      icon: DownloadIcon,
      onClick: () =>
        dispatch(
          DownloadFileFolderZIPAction({
            fileId: [],
            folderId: selectedIds,
          }),
        ),
    },
    ...(item?.permission !== "view" && selectedIds.length <= 1 ? [{
      label: t("common.rename"),
      icon: RenameIcon,
      onClick: () =>
        dispatch(
          openCenterModal({
            content: (
              <CreateRenameModal
                title={t("modal.rename.renameFolder")}
                btnName={t("common.rename")}
                type={"rename"}
                item={item}
                clearSelection={clearSelection}
              />
            ),
          }),
        ),
    }
    ] : []),

    // item?.permission === "owner" && {
    //   label: t("move"),
    //   icon: MoveIcon,
    //   onClick: () =>
    //     dispatch(
    //       openCenterModal({
    //         content: <MoveFileFolderModal item={item} onClose={handleClose} />,
    //       }),
    //     ),
    // },

    ...(selectedIds.length <= 1 ? [{
      label: t("common.folderInformation"),
      icon: InfoIcon,
      onClick: () =>
        dispatch(
          openCenterModal({
            content: (
              <InformationModal
                title={t("modal.info.folderDetails")}
                item={{
                  type: "folder",
                  size: item?.folder_size,
                  owner: item?.owner?.email,
                  date: item?.updated_at,
                  location: item?.full_path || item?.name,
                  shared_by: driveData?.folder?.shared_by?.email,
                  permission: item?.permission,
                  isShared: item?.shared_by,
                  isParentOwner: item?.parent_owner,
                  isUser: item?.user,
                }}
              />
            ),
          }),
        ),
    }] : []),
    item?.permission === "owner" && {
      label: t("common.moveToTrash"),
      icon: RemoveIcon,
      onClick: () =>
        dispatch(
          openCenterModal({
            content: (
              <CommonDeleteModal
                title={t(
                  selectedIds.length > 1
                    ? "modal.moveToTrash.moveFoldersToTrash"
                    : "modal.moveToTrash.moveFolderToTrash",
                )}
                description={t(
                  selectedIds.length > 1
                    ? "modal.moveToTrash.removeSelectedfolders"
                    : "modal.moveToTrash.moveFolderToTrashDescr",
                )}
                btnName={t("common.moveToTrash")}
                onClick={() =>
                  dispatch(
                    TrashFilesFolderAction({
                      ids: selectedIds,
                      onSuccess: () => {
                        clearSelection?.();
                      },
                    }),
                  )
                }
              />
            ),
          }),
        ),
    },
    // {
    //   label: t("reportOrBlock"),
    //   icon: ReportIcon,
    //   rightArrow: true,
    //   submenu: [
    //     {
    //       label: t("report"),
    //       icon: ReportIcon,
    //       onClick: () =>
    //         dispatch(openCenterModal({ content: <ReportModal /> })),
    //     },
    //     {
    //       label: `${t("block")} designer@bigfootmail.com`,
    //       icon: BlockIcon,
    //       onClick: () =>
    //         dispatch(openCenterModal({ content: <BlockUserModal /> })),
    //     },
    //   ],
    // },
  ].filter(Boolean);

  const trashOptions = [
    {
      label: t("trash.restore"),
      icon: RestoreIcon,
      onClick: () =>
        dispatch(
          RestoreFilesFolderAction({
            ids: selectedIds,
            onSuccess: () => {
              clearSelection?.();
            },
          }),
        ),
    },
    {
      label: t("trash.deleteForever"),
      icon: DeleteForeverIcon,
      onClick: () =>
        dispatch(
          openCenterModal({
            content: (
              <CommonDeleteModal
                title={t("trash.deleteFolderForever")}
                description={t("trash.areYouSureDeleteFolderForever")}
                btnName={t("trash.delete")}
                onClick={() =>
                  dispatch(
                    DeletePermanentlyFilesFolderAction({
                      ids: selectedIds,
                      onSuccess: () => {
                        clearSelection?.();
                      },
                    }),
                  )
                }
              />
            ),
          }),
        ),
    },
  ];

  const menuItems = page === "trash" || item?.is_trashed ? trashOptions : folderOptions;

  return (
    <>
      <MuiIconButton src={MoreIcon} size="24px" onClick={handleOpen} />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorReference={contextMenu ? "anchorPosition" : "anchorEl"}
        MenuListProps={{ disablePadding: true }}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        anchorPosition={
          contextMenu
            ? {
              top: contextMenu.mouseY,
              left: contextMenu.mouseX,
            }
            : undefined
        }
        slotProps={{
          paper: {
            sx: {
              maxWidth: "300px",
              width: "100%",
              boxShadow: "0px 6px 24px 0px #0000000D",
              p: "4px",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "background.gray400",
            },
          },
        }}
      >
        {menuItems.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={(e) => {
              e.stopPropagation();
              if (item.submenu) {
                handleSubmenuOpen(e, item.submenu, idx);
              } else {
                item.onClick && item.onClick();
                handleClose();
              }
            }}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              p: "8px 12px",
              borderRadius: "8px",
              bgcolor:
                activeParent === idx ? "background.blue200" : "transparent",
            }}
          >
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MuiBox sx={{ height: "24px", width: "24px" }}>
                <img src={item.icon} alt="" className="img-full" />
              </MuiBox>
              <MuiTypography
                fontWeight="400"
                variant="14"
                color="text.darkBlack"
              >
                {item.label}
              </MuiTypography>
            </MuiBox>
            {item.rightArrow && (
              <MuiBox sx={{ height: "24px", width: "24px" }}>
                <img src={RightArrow} alt="" className="img-full" />
              </MuiBox>
            )}
          </MenuItem>
        ))}
      </Menu>
      <Menu
        anchorEl={submenuAnchor}
        open={submenuOpen}
        onClose={handleSubmenuClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        MenuListProps={{ disablePadding: true }}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        slotProps={{
          paper: {
            sx: {
              width: "100%",
              maxWidth: "300px",
              boxShadow: "0px 6px 24px 0px #0000000D",
              p: "4px",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "background.gray400",
              ml: "8px",
            },
          },
        }}
      >
        {submenuItems.map((subItem, idx) => (
          <MenuItem
            key={idx}
            onClick={(e) => {
              e.stopPropagation();
              subItem.onClick && subItem.onClick();
              handleClose();
            }}
            sx={{ p: "8px 12px", borderRadius: "8px" }}
          >
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MuiBox sx={{ height: "24px", width: "24px" }}>
                <img src={subItem.icon} alt="" className="img-full" />
              </MuiBox>
              <MuiTypography
                fontWeight="400"
                variant="14"
                color="text.darkBlack"
              >
                {subItem.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FolderMenu;
